<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <collapse @getDataList="search">
        <collapse-item>
          <span>账户</span>
          <el-input placeholder="账户" v-model="queryInfoparams.params.loginAccount" clearable
          @change="search"
            @clear="queryInfoparams.params.loginAccount==null"
            ></el-input>
        </collapse-item>
        <collapse-item>
          <span>邮箱</span>
          <el-input placeholder="邮箱" v-model="queryInfoparams.params.email" clearable
          @change="search"
            @clear="queryInfoparams.params.email==null"
            ></el-input>
        </collapse-item>
        <collapse-item>
          <span>姓名</span>
          <el-input placeholder="姓名" v-model="queryInfoparams.params.userName" clearable
          @change="search"
            @clear="queryInfoparams.params.userName==null"
            ></el-input>
        </collapse-item>
      </collapse>

      <!-- 搜索与添加区域 -->

      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button
              plain
              size="small"
              icon="el-icon-plus"
              v-hasPermission="['user:save']"
              @click="addDialogVisible = true"
            >新增用户</el-button>
            <el-button
              plain
              size="small"
              icon="el-icon-download"
              v-hasPermission="['user:export']"
              @click="exportExcel"
            >导出excel</el-button>
          </el-button-group>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="userList" border stripe>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="姓名" sortable prop="userName"></el-table-column>
        <el-table-column label="帐号" sortable prop="loginAccount"></el-table-column>
        <el-table-column label="邮箱" sortable prop="email"></el-table-column>
        <el-table-column label="用户类型" sortable prop="userType">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.userType==='1'" type="success">总部用户</el-tag>
            <el-tag v-else-if="scope.row.userType==='2'" type="info">代理商</el-tag>
            <el-tag v-else-if="scope.row.userType==='3'" type="info">水工公司</el-tag>
            <el-tag v-else type="warning">水工</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="所属角色"  prop="roleName"></el-table-column>
        <el-table-column label="状态" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='1'" type="success">生效</el-tag>
            <el-tag v-else-if="scope.row.status==='2'" type="info">锁定</el-tag>
            <el-tag v-else-if="scope.row.status==='3'" type="warning">废弃</el-tag>
            <el-tag v-else type="warning"></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-link
              icon="el-icon-edit"
              @click="showEditDialog(scope.row.id)"
              v-hasPermission="['user:save']"
            >编辑</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link
              icon="el-icon-delete"
              @click="removeUserById(scope.row.id)"
              v-hasPermission="['user:delete']"
            >删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="Add User" :visible="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="120px">
        <el-form-item label="账户" label-width="120px" prop="loginAccount">
          <el-input @blur="checkUserExist" v-model="addForm.loginAccount"></el-input>
        </el-form-item>
        <el-form-item label="姓名" label-width="120px" prop="userName">
          <el-input v-model="addForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="120px" prop="inputPassword">
          <!-- <el-input v-model="addForm.inputPassword" type="password" placeholder="包含数字和字母，不能少于8位"></el-input> -->
           <passinput v-model="addForm.inputPassword" placeholder="包含数字和字母，不能少于8位"></passinput>
        </el-form-item>
        <el-form-item label="用户类型" label-width="120px" prop="userType">
          <el-input placeholder="总部员工" disabled></el-input>
        </el-form-item>

        <el-form-item label="角色权限:" prop="selectedRoleList" label-width="120px">
          <el-select
            v-model="addForm.selectedRoleList"
            multiple
            placeholder="请选择角色权限"
            @change="roleChange"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.role_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮箱" label-width="120px" prop="email">
          <el-input v-model="addForm.email"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" label-width="120px">
          <el-radio-group v-model="addForm.status">
            <el-radio-button label="1">生效</el-radio-button>
            <el-radio-button label="2">锁定</el-radio-button>
            <el-radio-button label="3">废弃</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框  此处可与添加用户 优化合并为一个对话框-->
    <el-dialog title="编辑用户" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="120px">
        <el-form-item label="账户" prop="loginAccount" label-width="120px">
          <el-input v-model="addForm.loginAccount" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName" label-width="120px">
          <el-input v-model="addForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="密码" label-width="120px">
          <!-- <el-input v-model="addForm.inputPassword" type="password" placeholder="包含数字和字母，不能少于8位"></el-input> -->
          <passinput v-model="addForm.inputPassword" placeholder="包含数字和字母，不能少于8位"></passinput>
        </el-form-item>
        <el-form-item label="用户类型" prop="userType" label-width="120px">
          <el-input v-if="addForm.userType == 1" placeholder="总部用户" disabled></el-input>
        </el-form-item>
        <el-form-item label="角色权限:" prop="selectedRoleList" label-width="120px">
          <el-select
            v-model="addForm.selectedRoleList"
            multiple
            placeholder="请选择角色权限"
            @change="roleChange"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.role_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" label-width="120px">
          <el-input v-model="addForm.email"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" label-width="120px">
          <el-radio-group v-model="addForm.status">
            <el-radio-button label="1">生效</el-radio-button>
            <el-radio-button label="2">锁定</el-radio-button>
            <el-radio-button label="3">废弃</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
import passinput from '@/components/passInput/PassInput.vue'

export default {
  components: {
    Collapse,
    CollapseItem,
    passinput
  },
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 用户列表
      userList: [],
      total: 0,
      // 控制添加 用户对话框的显示与隐藏
      addDialogVisible: false,
      // 添加和修改用户的表单数据
      addForm: {
        loginAccount: '',
        userName: '',
        userType: '1',
        email: '',
        status: '1',
        inputPassword: '',
      },

      // 添加表单的验证规则对象
      addFormRules: {
        loginAccount: [
          { required: true, message: '账户不能为空', trigger: 'blur' },
        ],
        selectedRoleList: [
          { required: true, message: '角色权限不能为空', trigger: 'blur' },
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        inputPassword: [
          {
            required: true,
            message: '请输入密码：包含数字和字母，不能少于8位',
            trigger: 'blur',
          },
          {
            min: 8,
            message: '密码不能少于8位',
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
      },
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,

      // 查询到的用户信息
      editForm: {},

      //角色列表
      roleList: [],

      // selectedRoleList:[],
    }
  },
  created() {
    this.search()
    this.getDictList()
  },
  methods: {
    roleChange(val) {
      console.log('----------', val)
      console.log('roleIds:', this.addForm.roleIds)
    },
    //导出excel
    exportExcel() {
      console.log('-----------')
      let res = this.$export('user/exportExcel', JSON.stringify(this.queryInfoparams), 'user')
    },
    // 添加用户的时候判断 账户是否存在
    async checkUserExist() {
      if (this.addForm.loginAccount == '') return
      this.$get(`user/existsUser/${this.addForm.loginAccount}`).then(
        ({ data: res }) => {
          if (res.data === false) {
            this.$message.error('该账户已存在')
            setTimeout(() => {
              this.addForm.loginAccount = ''
            }, 1000)
          }
        }
      )
    },
    //获取数据字典列表
    getDictList() {
      this.$get(`role/selectByTypePermission/SYSTEM`).then(({ data: res }) => {
        console.log(res)
        this.roleList = res.data
      })
    },
    search(){
        this.queryInfoparams.current=0
         this.getUserList()
    },
    // 获取 查询用户数据列表
    async getUserList() {
      // 分页查询用户
      this.$post('user/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.userList = res.records
          this.total = res.total
        }
      )
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getUserList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getUserList()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.addForm = { status: '1', inputPassword: 'rf654321@!' }
      this.addForm.selectedRoleList = []
      this.addDialogVisible = false
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮 添加新用户
    async addUser() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        console.log(this.addForm)

        if (
          this.addForm.selectedRoleList == null ||
          this.addForm.selectedRoleList == undefined ||
          this.addForm.selectedRoleList.size <= 0
        ) {
          this.$message.error('角色权限不能为空')
          return
        }
        var tempList = this.addForm.selectedRoleList

        this.addForm.roleIdStr = this.addForm.selectedRoleList.join(',')

        this.addForm.selectedRoleList = null

        // 新增用户 编辑用户都是这个接口
        this.$post('user/save', this.addForm).then(({ data: res }) => {
          if (!res.ok) {
            this.addForm.selectedRoleList = tempList
            return this.$message.error('添加用户失败')
          }

          this.$message.success('添加用户成功')
          // 隐藏添加用户的对话框
          this.addDialogClosed()
          // 刷新户列表数据
          this.search()
        })
      })
    },
    // 展示编辑用户的对话框
    async showEditDialog(id) {
      this.editDialogVisible = true
      this.$get(`user/getUser/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = res.data
        this.addForm.selectedRoleList = res.data.selectedRoleList
      })
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.addForm = { status: '1', selectedRoleList: [] }

      this.editDialogVisible = false
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    editUserInfo() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return

        if (
          this.addForm.selectedRoleList == null ||
          this.addForm.selectedRoleList == undefined ||
          this.addForm.selectedRoleList.size <= 0
        ) {
          this.$message.error('角色权限不能为空')
          return
        }
        var tempList = this.addForm.selectedRoleList
        this.addForm.roleIdStr = this.addForm.selectedRoleList.join(',')
        this.addForm.selectedRoleList = null
        this.$post('user/save', this.addForm).then(({ data: res }) => {
          console.log(res)
          if (!res.ok) {
            this.addForm.selectedRoleList = tempList
            return this.$message.error('编辑用户信息失败')
          }

          this.$message.success('编辑用户信息成功')
          // 关闭对话框
          this.editDialogClosed()
          // 刷新数据列表
          this.search()
        })
      })
    },
    // 根据id删除对应的用户信息
    async removeUserById(id) {
      // 弹框询问用户是否删除用户

      const confirmResult = await this.$confirm(
        '此操作将永久删除该用户, 是否继续?',
        '删除用户',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$get(`user/delete/${id}`).then(({ data: res }) => {
            if (!res.ok) {
              return this.$message.error(res.msg)
            }
            this.$message.success(res.msg)

            this.search()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

.el-tag {
  border: none !important;
}

.collapse {
  display: flex;
  justify-content: space-between;
}
</style>